module.exports = __webpack_public_path__ + "img/w6-b1.aca94e4f.jpg";